import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import Graph from "@components/graphStatistics/Pie/Graphs";
import { customTooltips } from "@helpers/_functions";

export default function Index({ parity, title }) {
  const { t } = useTranslation("pages.employés.statistics");
  const [graphData, setGraphData] = useState({});
  const chartRef = useRef(null);

  useEffect(() => {
    if (parity?.length) {
      const parityData = {
        datasets: [
          {
            data: parity.map((item) => item.count) || [],
            backgroundColor: parity.map((item) => item.backgroundColor),
            name: parity.map((item) => item.name),
          },
        ],
        labels: parity.map(({name, count, additional }) => `${name} : ${count} (${additional}%)`),
      };

      setGraphData(parityData);
    }
  }, [parity]);

  const translatedGraphData = {
    datasets: graphData?.datasets || [],
    labels: graphData?.labels || [],
  };

  const translatedLegends = parity
    ?.map(({ name, backgroundColor }) => ({
      name: t(name),
      backgroundColor,
    }))
    .sort(({ name: nameA }, { name: nameB }) => (nameA?.toLowerCase() < nameB?.toLowerCase() ? -1 : 1));

 
  

  const customOptions = {
    tooltips: {
      enabled:false,
      custom: (tooltip)=>customTooltips(tooltip,chartRef,t),
    },
  };
  
  return (
    <Graph
      graphData={translatedGraphData}
      legends={translatedLegends}
      title={title}
      spaceLegende="arh-space-y-2"
      customOptions={customOptions}
      chartRef={chartRef} 
    />
  );
}
